module.exports = __webpack_public_path__ + "media/images/web/home/index/bg_hero-1eb49ae1cb06d0a54ee123b7db1488f9.jpg";